export const EVENT = Object.freeze({ CLEAR_TEXTAREA: 'clear_textarea' });

export default function event(eventName: string, data?: any) {
  window.dispatchEvent(new CustomEvent(eventName, { detail: data }));
}
